/**
 * Shared video embed utilities — extracted from EndPageRenderer.jsx.
 *
 * Used by both EndPageRenderer (end page video blocks) and PublicForm
 * (splash page video blocks) to avoid duplication.
 */

export function extractYouTubeId(url) {
    if (!url) return null;
    const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return m ? m[1] : null;
}

export function extractVimeoId(url) {
    if (!url) return null;
    const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : null;
}

/**
 * Resolve a video URL to an embeddable iframe src.
 * Supports YouTube and Vimeo. Returns the original URL if it's not
 * a recognized video provider (caller can decide how to handle).
 *
 * @param {string} url - video URL
 * @returns {{ src: string, isEmbed: boolean } | null}
 */
export function getVideoEmbed(url) {
    if (!url) return null;
    const yt = extractYouTubeId(url);
    if (yt) return { src: `https://www.youtube.com/embed/${yt}`, isEmbed: true };
    const vimeo = extractVimeoId(url);
    if (vimeo) return { src: `https://player.vimeo.com/video/${vimeo}`, isEmbed: true };
    return { src: url, isEmbed: false };
}
